import React from 'react';

import { toLocale } from '../../helpers/numberHelper';

import './changeCard.style.css';

const changeCard = ({ value }) => {
    let displayValue = 'N/A';
    let colour = '';
    if (value !== null) {
        displayValue = `${value > 0 ? '+' : ''}${toLocale(value)}`;
        if (value !== 0) {
            colour = value > 0 ? 'ChangeCardValueGreen' : 'ChangeCardValueRed';
        }
    }

    return (
        <div className="ChangeCard">
            <span className="ChangeCardLabel">Change</span>
            <div className={`ChangeCardValue ${colour}`}>{displayValue}</div>
            <div className="ChangeCardSubLabel">
                <div>Yesterday</div>
            </div>
        </div>
    );
};

export default changeCard;
